import React, {FC} from 'react';
import {FormNameEnum} from 'filters-selections';
import {TextInputSelection} from '../TextInputSelection/TextInputSelection';
import {IWithDisabled} from 'models/common';

type IDisplayNameTextInputProps = IWithDisabled;

export const DisplayNameTextInput: FC<IDisplayNameTextInputProps> = ({disabled}) => (
  <TextInputSelection name={FormNameEnum.displayName} label="Display Name" disabled={disabled} />
);
